import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { COLUMN_WIDTH_100 } from '@modules/page-builder/config/column-constants';

export const PADDING_TOP_BOTTOM_SECTION = 120;
export const PADDING_LEFT_RIGHT_SECTION = 50;
export const PADDING_LEFT_RIGHT_SECTION_MOBILE = 18;
export const MODAL_BOX_SHADOW = `0px 14px 24px 2px rgba(0, 0, 0, 0.08)`;

export const PADDING_TOP_CAPTION_MOBILE = 16;

export const SingleImageContainer: StyleRule = ({
    theme,
    fullScreen,
    inViewport,
    moduleType,
}) => ({
    width: '100%',
    margin: '0 auto',
    transition: 'width 0.5s ease-in-out',
    [theme.screen.laptop]: {
        height: 'auto',
        width:
            moduleType === 'MediumSingleImageModule'
                ? '65% !important' // Medium image is roughly 65% of the width of largeimages
                : fullScreen && inViewport
                  ? '100%'
                  : pxToRem(COLUMN_WIDTH_100),
    },
});

export const FullPageImageContainer: StyleRule = ({ theme }) => ({
    width: '100%',
    margin: '0 auto',

    [theme.screen.laptop]: {
        padding: '0',
        margin: '0',
        width: '100%',
    },
});
